import React from 'react';
import PropTypes from 'prop-types';
import { ContentBoxContainer, ContentBoxText } from 'components';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

const responsive = {
    superLargeDesktop: {
        // the naming can be any, depends on you.
        breakpoint: { max: 4000, min: 3000 },
        items: 5,
    },
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 3,
    },
    tablet: {
        breakpoint: { max: 1024, min: 464 },
        items: 2,
    },
    mobile: {
        breakpoint: { max: 464, min: 0 },
        items: 1,
    },
};

const Testimonials = ({ className, ...props }) => {
    const testimonials =
         [

             {
                 text: 'Jeg har oplevet en unik tilgang til rådgivning. Jeg har prøvet andre rådgivere, men det her er noget helt særligt. Det er uvildigt, grundigt, respektfuldt og skræddersyet til min situation, hvilket har skabt stor værdi for mig.',
                 name: 'Lone',
                 imageUrl: '/static/gfx/content/penly-testimonial-lone-siemen.jpg',
                 isModel: true,
             },
             {
                 text: 'Første rådgivning gav mig ro – anden ændrede mit liv. Jeg troede, jeg skulle arbejde seks år mere, men pludselig kunne jeg gå på pension ugen efter.',
                 name: 'Charlotte Jørgensen',
                 imageUrl: '/static/gfx/content/penly-testimonial-charlotte-joergensen.jpg',
             },
             {
                 text: 'Nedsparingsrådgivningen har givet mig en opskrift på, hvordan det ser ud, når jeg skal på pension. Det har givet mig et super godt overblik og en indre ro.',
                 name: 'Tove Nørgaard',
                 imageUrl: '/static/gfx/content/penly-testimonial-tove-nedsparing.jpg',
             },
             {
                 text: 'Nu ved jeg nøjagtig, hvordan det ser ud, hvis jeg går på pension som 60-, 65- eller 68-årig og hvordan jeg skal spare op i årene før, for at få mest ud af mine penge. Det har givet mig ro at få det overblik.',
                 name: 'Henrik Møller-Jørgensen',
                 imageUrl: '/static/gfx/content/penly-testimonial-henrik.jpg',
             },
             {
                 text: 'Rådgiveren kom med meget konkrete handlemuligheder, og der var fuld respekt for, at det skal føles rigtigt i vores mave. Vi blev således meget klogere og i stand til at træffe de beslutninger, der var rigtige for os.',
                 name: 'Tina Kierbyholm',
                 imageUrl: '/static/gfx/content/penly-testimonial-tina-kierbyholm.jpeg',
             },
             {
                 text: 'Pengene til den uvildige rådgiver er givet godt ud, og det er jo peanuts, i forhold til det jeg har fået. Det kan koste dyrt, hvis man ikke gør det rigtigt.',
                 name: 'Birthe Monrad',
                 imageUrl: '/static/gfx/content/penly-testimonial-birthe-monrad.jpg',
             },
             {
                 text: 'Jeg er meget tilfreds med nedsparingsrådgivningen, da jeg nu har overblik over og kan gennemskue min økonomiske situation som pensionist. Rådgivningen har desuden øget udbyttet af mine pensioner med 50.000 kr. i alt.',
                 name: 'Katja Bundgaard',
                 imageUrl: '/static/gfx/content/katja-bundgaard.jpg',
             },
             {
                 text: 'Rådgiveren hjalp os med at få et godt overblik over vores økonomi ud fra forskellige muligheder. Han var utrolig god til at forklare det komplicerede på en enkel måde.',
                 name: 'Leila Boel',
                 imageUrl: '/static/gfx/content/leila-boel.jpg',
             },
             {
                 text: 'Rådgivningen gav os god ro i maven. Vi fik klarhed over, hvilke pensioner vi skulle starte med. Beregningerne viste, at vi kan optimere vores pension med 275.000 kr., hvis vi følger anbefalingerne.',
                 name: 'Ruth og Erik Silberbauer',
                 imageUrl: 'https://storage.googleapis.com/penly-strapi/Ruth_og_Erik_fik_flere_penge_til_pension_316ecb972a.jpg',
             },

         ];
    // : [
    //       {
    //           text: 'Jeg var bekymret for, om vi sparede forkert op til alderdommen. Penlys pensionstjek har givet mig overblik over mine muligheder og ro i maven.',
    //           name: 'Lone Salling',
    //       },
    //       {
    //           text: 'Der blev fundet et par væsentlige ting jeg aldrig selv havde fundet frem til, som gør at min pension ser meget mere attraktiv ud, når tiden kommer. Så tusind tak til jer for hjælpen! :-)',
    //           name: 'Alan Hartman',
    //       },
    //       {
    //           text: 'Det der bekymrede mig mest, var om jeg var tilstrækkeligt sikret økonomisk i forhold til min pension. Penlys pensiontjek gav mig vished om, at jeg med min opsparing, mine investeringer og min friværdi i huset er sikret et godt pensionistliv.',
    //           name: 'Eric Pratt',
    //       },
    //   ];

    // Get random testimonials
    // const testimonials = disableRandom
    //     ? testimonialTexts
    //     : testimonialTexts
    //           .map((value) => ({ value, sort: Math.random() }))
    //           .sort((a, b) => a.sort - b.sort)
    //           .map(({ value }) => value);
    return (
        <ContentBoxContainer className="testimonials-carousel">
            <ContentBoxText className="single paddingSmaller brtl brbr"  style={{ display: 'flex', flexDirection: 'column-reverse' }}>
                <Carousel responsive={ responsive }  autoPlay={ true } autoPlaySpeed={ 5000 } infinite={ true } ssr={ true }>
                    { testimonials.map((testimonial, index) => (
                        <div key={ index } className="testimonial-item" >
                            <div style={{ width:'100%' }}>
                                { testimonial.imageUrl && (
                                    <div className="image-container">
                                        <div className="round-image" style={{ backgroundImage: `url(${testimonial.imageUrl})` }}></div>
                                    </div>
                                ) }
                                <p>{ testimonial.text }</p>
                                <div>{ testimonial.name } { testimonial.isModel && <span style={{ fontWeight:400, fontSize: 12 }}>(Modelfoto)</span> }</div>

                            </div>
                        </div>
                    )) }
                </Carousel>
                <h2 className="color-primary" style={{ textAlign: 'center', marginTop: 0 }}>
                    HVAD SIGER ANDRE OM VORES ­RÅDGIVNING?
                </h2>
            </ContentBoxText>
        </ContentBoxContainer>
        // :
        // <ContentBoxContainer className={classNames} {...props}>
        //         {
        //             <>
        //                 <ContentBoxText className="single paddingSmaller multipleTestimonials brtl brbr" style={{ display: 'flex', flexDirection: 'column-reverse' }}>
        //                     <div>
        //                         {testimonials.map((testimonial, index) => (
        //                             <div key={index}>
        //                                 {testimonial.imageUrl && (
        //                                     <div className="image-container">
        //                                         <div className="round-image" style={{ backgroundImage: `url(${testimonial.imageUrl})` }}></div>
        //                                     </div>
        //                                 )}
        //                                 <p>{testimonial.text}</p>
        //                                 <div>{testimonial.name}</div>
        //                             </div>
        //                         ))}
        //                     </div>
        //                     {props.title && (
        //                         <h2 className="color-primary" style={{ textAlign: 'center', marginTop: 0 }}>
        //                             {props.title}
        //                         </h2>
        //                     )}
        //                 </ContentBoxText>
        //             </>
        //         }
        //     </ContentBoxContainer>
    );
};

Testimonials.propTypes = {
    className: PropTypes.string,
    props: PropTypes.array,
};

export default Testimonials;
